import React from 'react'

const VerticalCardTopRight: React.FC = props => {
    return <>{props.children}</>
}

export default VerticalCardTopRight
